import { requests } from 'api';
import { Origin } from './types';

const apiBaseUrl = '/api/origins';

export const OriginsApi = {
  getAll: (): Promise<Origin[]> => requests.get(apiBaseUrl),
};
